import React from "react";
import { useTable } from "../../Components/useTable";

const FamilyReport = () => {
  const type = "Family Report";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "familyname", numeric: false, label: "Name" },
    { id: "familycode", numeric: false, label: "RID" },
    { id: "familyno", numeric: false, label: "Phone no" },
    { id: "picture", numeric: false, label: "Image" },
    { id: "reason", numeric: false, label: "Reason" },
    { id: "type", numeric: false, label: "Type" },
    { id: "reporterUser", numeric: false, label: "Report Name" },
    { id: "reporterRID", numeric: false, label: "Report RID" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "respondedUser", numeric: false, label: "Respond Name" },
    { id: "respondedcode", numeric: false, label: "Respond RID" },
    { id: "adminImage", numeric: false, label: "Image" },
    { id: "created", numeric: false, label: "Date" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default FamilyReport;
